var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-gray-200 pt-3"},[_c('div',{staticClass:"py-3 flex justify-center"},_vm._l((_vm.filteredFlowItem),function(item,index){return _c('div',{key:index,class:_vm.isClass(index)},[_c('i'),_c('abbr'),_c('span',{staticClass:"inline-block pt-3 name-label text-xs sm:text-xs md:text-sm"},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }